import { ComponentLoader } from '@bythepixel/component-loader';
import InViewSrc from '@bythepixel/in-view-src';
import InViewSrcset from '@bythepixel/in-view-srcset';

import {
  FinancingForm,
  PartsDeliveryForm,
  PartsPickUpForm,
  RentalForm,
  SalesForm,
  SellMyRvForm,
  ServiceForm,
} from '@Front/global/leadForms/index';

import AsyncIframe from './asyncIframe';
import Accordion from './accordion';
import AlertBanner from './alertBanner';
import CareersHeaderScroll from './careersHeaderScroll';
import CollapsibleText from './collapsibleText';
import CopyLink from './copyLink';
import HeroVideo from './heroVideo';
import InputGroup from './inputGroup';
import LongFormContent from './longFormContent';
import Matterport from './matterport';
import Modal from './modal';
import ModalPopup from './modalPopup';
import SearchHero from './searchHero';
import SectionSimilarVehiclesSlider from './sliders/sectionSimilarVehiclesSlider';
import SectionTabs from './tabs/sectionTabs';
import SectionTestimonialSlider from './sliders/sectionTestimonialSlider';
import SectionGeneralSlider from './sliders/sectionGeneralSlider';
import SectionMediaGallerySlider from './sliders/sectionMediaGallerySlider';
import SectionSubNavProductDetails from './sectionSubNavProductDetails';
import SectionThreeColumnSlider from './sliders/sectionThreeColumnSlider';
import StickyContainer from './stickyContainer';
import SubNav from './subNav';
import ThumbsGallery from './sliders/thumbsGallery';
import TrackClickEvent from './trackClickEvent';

window.global = new ComponentLoader(document, [
  InViewSrc,
  InViewSrcset,
  AsyncIframe,
  Accordion,
  AlertBanner,
  CareersHeaderScroll,
  CollapsibleText,
  CopyLink,
  HeroVideo,
  InputGroup,
  LongFormContent,
  Matterport,
  Modal,
  ModalPopup,
  SearchHero,
  SectionSimilarVehiclesSlider,
  SectionTabs,
  SectionTestimonialSlider,
  SectionGeneralSlider,
  SectionThreeColumnSlider,
  SectionMediaGallerySlider,
  SectionSubNavProductDetails,
  StickyContainer,
  SubNav,
  ThumbsGallery,
  TrackClickEvent,
  // Forms
  FinancingForm,
  PartsDeliveryForm,
  PartsPickUpForm,
  RentalForm,
  SalesForm,
  SellMyRvForm,
  ServiceForm,
]);
